export default __webpack_public_path__ + "static/media/instagram-4x.cf8c868d.png";